import { render, staticRenderFns } from "./MultiChart.vue?vue&type=template&id=10d1b3f6&scoped=true"
import script from "./MultiChart.vue?vue&type=script&lang=js"
export * from "./MultiChart.vue?vue&type=script&lang=js"
import style0 from "./MultiChart.vue?vue&type=style&index=0&id=10d1b3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1b3f6",
  null
  
)

export default component.exports